import { useTranslation } from 'react-i18next';
import { Crown, Lock } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface HistoryLimitOverlayProps {
  historyMonths: number;
}

export default function HistoryLimitOverlay({ historyMonths }: HistoryLimitOverlayProps) {
  const { t } = useTranslation('subscription');
  const navigate = useNavigate();

  return (
    <div className="relative">
      {/* Overlay flou */}
      <div className="absolute inset-0 z-10 backdrop-blur-md bg-white/60 rounded-xl flex items-center justify-center">
        <div className="flex flex-col items-center gap-4 p-8 max-w-md text-center">
          <div className="w-16 h-16 rounded-full bg-primary-100 flex items-center justify-center">
            <Lock className="w-8 h-8 text-primary-600" />
          </div>
          <h3 className="text-lg font-semibold text-gray-900">
            {t('historyLimit.title')}
          </h3>
          <p className="text-sm text-gray-600">
            {t('historyLimit.message', { count: historyMonths })}
          </p>
          <button
            onClick={() => navigate('/dashboard/abonnement')}
            className="btn-primary flex items-center gap-2"
          >
            <Crown className="w-4 h-4" />
            {t('historyLimit.upgrade')}
          </button>
        </div>
      </div>

      {/* Contenu placeholder flouté en dessous (hauteur minimale pour le visuel) */}
      <div className="min-h-[400px] opacity-30 pointer-events-none select-none" aria-hidden="true">
        {/* Fausses cartes pour donner l'illusion de contenu */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
          <div className="h-24 bg-gray-200 rounded-xl animate-pulse" />
          <div className="h-24 bg-gray-200 rounded-xl animate-pulse" />
          <div className="h-24 bg-gray-200 rounded-xl animate-pulse" />
        </div>
        <div className="h-64 bg-gray-200 rounded-xl animate-pulse mb-6" />
        <div className="h-48 bg-gray-200 rounded-xl animate-pulse" />
      </div>
    </div>
  );
}
